import { useEffect } from "react";
import useSWR from "swr";
import {
  registerVersionStates,
  type VersionStateDef,
} from "@/constants/version-state";

// Runtime state catalog (version_state table, Admin-managed). Mounted once in
// the authed shell so the registry fills early; config screens also call it
// to re-render when the catalog arrives or changes.
export const useVersionStates = (
  enabled = true
): VersionStateDef[] | undefined => {
  const { data } = useSWR<VersionStateDef[]>(
    enabled ? ["/version-states"] : null
  );
  useEffect(() => {
    if (data) registerVersionStates(data);
  }, [data]);
  return data;
};
